import React from 'react';
import { SelectPicker } from 'rsuite';

import './styles.css';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {import('rsuite').SelectPickerProps} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomToggle component.
 */

export function CustomSelectPicker({ ...rest }) {
  return <SelectPicker {...rest} className="custom-select-picker" />;
}
